import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Router, RouterLink} from "@angular/router";
import {AmplifyAuthenticatorModule} from "@aws-amplify/ui-angular";
import {AuthenticationService} from "../../services/authentication.service";
import {SeasonService} from "../../services/season.service";
import {ToastService} from "../../core/notifications/toast-service";
import {ImageService} from "../../services/image.service";

@Component({
  selector: 'app-landing-page',
  standalone: true,
  imports: [
    AmplifyAuthenticatorModule,
    RouterLink,
  ],
  templateUrl: './landing-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './landing-page.component.scss'
})
export class LandingPageComponent implements OnInit{

  prices_url: string = ""

  constructor(private authenticationService: AuthenticationService,
              private seasonService: SeasonService,
              private toastService: ToastService,
              private router: Router) {
  }

  ngOnInit(): void {
    this.authenticationService.isLoggedIn$
      .subscribe(isLoggedIn => {
        if (isLoggedIn) {
          this.router.navigate(['home', 'user'])
        }
      })

    this.seasonService.get_prices_url()
      .then(res => {
        this.prices_url = res.url;
      })
      .catch(error => {
        this.toastService.showDanger("Patreon Preise konnten nicht geladen werden!");
      })
  }
}
